<template>
  <div class="con-wrap">
    <el-aside width="280px">
      <el-row class="title" :gutter="20">
        <el-col :span="16">
          <div class="grid-content bg-purple">部门列表</div>
        </el-col>
      </el-row>
      <div>
        <el-tree
          :data="deptTreeData"
          node-key="id"
          @node-click="deptClick"
          ref="tree"
          default-expand-all
          highlight-current
          :expand-on-click-node="false"
        >
          <span class="custom-tree-node is-show" slot-scope="{ node }">
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </div>
    </el-aside>

    <el-container style="flex-direction: column; background-color: #f8f8f8">
      <div class="con-top">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">部门信息</div>
          </el-col>
        </el-row>
        <el-row class="top-btn">
          <el-col :span="16">
            <el-form style="margin-bottom: 20px">
              <el-button
                @click="editOrSave"
                v-if="hasPerm('maintain:dept:edit')"
                type="primary"
                >{{ btnName }}</el-button
              >
              <el-button
                v-if="hasPerm('maintain:group:list')"
                type="primary"
                @click="toDevopsGroup"
                style="width: 136px"
                >运维小组管理</el-button
              >
            </el-form>
          </el-col>
        </el-row>
        <div style="padding: 0 0 26px 20px">
          <table border="1" class="infoTable">
            <tr>
              <th class="table-header">部门名称</th>
              <td class="table-con">
                <template>
                  <el-input disabled v-if="isEdit" v-model="deptInfo.name" />
                  <span v-else>{{ deptInfoList.name }}</span>
                </template>
              </td>
              <th class="table-header">负责人</th>
              <td class="table-con">
                <template>
                  <el-input v-if="isEdit" v-model="deptInfo.leaderName" />
                  <span v-else>{{ deptInfoList.leaderName }}</span>
                </template>
              </td>
            </tr>
            <tr>
              <th class="table-header">运维人员（人）</th>
              <td class="table-con">
                <template>
                  <el-input
                    disabled
                    v-if="isEdit"
                    v-model="deptInfo.maintainNum"
                  />
                  <span v-else>{{ deptInfoList.maintainNum }}</span>
                </template>
              </td>
              <th class="table-header">联系电话</th>
              <td class="table-con">
                <template>
                  <el-input v-if="isEdit" v-model="deptInfo.phone" />
                  <span v-else>{{ deptInfoList.phone }}</span>
                </template>
              </td>
            </tr>
            <tr>
              <th class="table-header">办公地址</th>
              <td class="stable-con" colspan="3">
                <template>
                  <el-input v-if="isEdit" v-model="deptInfo.addr" />
                  <span v-else>{{ deptInfoList.addr }}</span>
                </template>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div style="background-color: #fff; height: 100%">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">运维人员</div>
          </el-col>
        </el-row>
        <div class="list-wrap">
          <el-form
            size="medium"
            :inline="true"
            :model="queryForm"
            ref="queryForm"
            class="input-form-inline"
            @submit.native.prevent
          >
            <div>
              <el-form-item class="r-20" prop="user">
                <el-input
                  v-model="queryForm.user"
                  @keyup.enter.native="query"
                  placeholder="请输入姓名"
                ></el-input>
              </el-form-item>
              <el-form-item class="r-20" prop="plate">
                <el-input
                  v-model="queryForm.plate"
                  @keyup.enter.native="query"
                  placeholder="请输入车牌号"
                ></el-input>
              </el-form-item>
              <el-button
                v-if="hasPerm('maintain:dept:list')"
                type="primary"
                @click="query"
                >查询</el-button
              >
              <el-button v-if="hasPerm('maintain:dept:list')" @click="reset"
                >取消</el-button
              >
            </div>
          </el-form>
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            size="mini"
            stripe
            height="418"
          >
            <el-table-column
              type="index"
              label="序号"
              width="55"
              align="center"
            ></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column
              prop="phone"
              label="联系电话"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="deptName"
              label="使用部门"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="groupName"
              label="运维小组"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="plateNum"
              label="车牌号"
              min-width="90"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column prop="vinBind" label="车辆绑定" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.vinBind == 1" class="btn-red"
                  >未绑定</span
                >
                <span v-else-if="scope.row.vinBind == 2" class="btn-green"
                  >已绑定</span
                >
                <span v-else></span>
              </template>
            </el-table-column>
            <el-table-column prop="situation" label="在职情况" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.situation == 1" class="btn-orange"
                  >在职</span
                >
                <span v-else-if="scope.row.situation == 2" class="btn-green"
                  >试用期</span
                >
                <span v-else-if="scope.row.situation == 3" class="btn-red"
                  >离职</span
                >
                <span v-else></span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  v-if="hasPerm('maintain:personnel:info')"
                  @click.stop="getUserInfo(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </el-container>
    <!--详情对话框-->
    <el-dialog
      title="详情"
      :visible.sync="infoVisible"
      class="mini-dialog info-box"
    >
      <p class="dialog-title">必填信息</p>
      <div style="padding: 0 60px; margin-bottom: 10px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">姓名</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.name) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">性别</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.sex) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">学历</el-col>
            <el-col :span="18">{{
              $judgeEmpty(staffInfo.educationStr)
            }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">身份证</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.numberId) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">联系电话</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.phone) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">所属代维专业</el-col>
            <el-col :span="18">{{
              $judgeEmpty(staffInfo.belongMaintainStr)
            }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">运维公司</el-col>
            <el-col :span="18">{{
              $judgeEmpty(staffInfo.maintainCompany)
            }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">合同到期时间</el-col>
            <el-col :span="18">{{
              $judgeEmpty(staffInfo.contractTime)
            }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">在职状态</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.situation) }}</el-col>
          </el-col>
        </el-row>
      </div>
      <p class="dialog-title">非必填信息</p>
      <div style="padding: 0 60px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">民族</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.nation) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">籍贯</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.hometown) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">家庭住址</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.addr) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">入职时间</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.entryTime) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">具备技能</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.skill) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">岗位职责</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.postDuty) }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">购买保险情况</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.insurance) }}</el-col>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-col :span="6" class="dialog-label">备注</el-col>
            <el-col :span="18">{{ $judgeEmpty(staffInfo.remark) }}</el-col>
          </el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="infoVisible = false">取 消</el-button>
        <el-button type="primary" @click="infoVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deptTreeData: [],
      // 表格
      isEdit: false,
      deptInfo: {
        addr: "",
        deptId: "",
        phone: "",
        leaderName: "",
      },
      deptInfoList: [],
      //编辑按钮
      btnName: "编辑",
      editFlag: 1,
      deptId: "",
      queryForm: {
        user: "",
        plate:''
      },
      tableData: [],
      currentPage: 1,
      limit: 10,
      total: 0,
      staffInfo: {},
      infoVisible: false,
    };
  },
  created() {
    if (sessionStorage.getItem("devopsDeptId")) {
      this.deptId = sessionStorage.getItem("devopsDeptId");
    }

    this.getDeptList();
  },
  watch: {
    deptTreeData(val) {
      let _this = this;
      if (val) {
        this.show = true;
        this.$nextTick(() => {
          if (_this.deptId == "") {
            document.querySelector(".el-tree-node__content").click();
          } else {
            console.log(_this.deptId);
            _this.$refs.tree.setCurrentKey(_this.deptId);
            _this.getDeptInfon(_this.deptId);
            _this.getUserList();
          }
        });
      }
    },
  },
  methods: {
    async getDeptList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/dept/list");
      if (res.code == 1) {
        if (res.data.length == 0) {
          _this.authorityData = [];
          _this.deptId = "";
        }
        _this.deptTreeData = res.data;
      } else {
        _this.authorityData = [];
        _this.deptId = "";
        _this.$message.warning(res.msg);
      }
    },
    deptClick(deptDatas) {
      this.deptId = deptDatas.id;
      sessionStorage.setItem("devopsDeptId", this.deptId);
      this.getDeptInfon(this.deptId);
      this.getUserList();
    },
    async getDeptInfon(id) {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/maintain/dept/" + id);
      if (res.code == 1) {
        _this.deptInfoList = res.data;
      } else {
        _this.deptInfoList = [];
        _this.$message.warning(res.msg);
      }
    },
    editOrSave() {
      if (this.isEdit) {
        const patter = new RegExp(
          "^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$"
        );
        if (this.deptInfo.phone) {
          if (!patter.test(this.deptInfo.phone)) {
            this.$message.warning("请输入正确格式的手机号！");
            return;
          }
        }
      }
      this.isEdit = !this.isEdit;
      if (this.editFlag == 2) {
        this.editFlag = 1;
        this.btnName = "编辑";
        this.saveDeptInfo(this.deptId);
      } else {
        this.deptInfo = this.deptInfoList;
        this.editFlag = 2;
        this.btnName = "保存";
      }
    },
    async saveDeptInfo(id) {
      let _this = this;
      let parm = {
        deptId: id,
        addr: _this.deptInfo.addr,
        leaderName: _this.deptInfo.leaderName,
        phone: _this.deptInfo.phone,
      };
      let { data: res } = await _this.$axios.patch(
        "/api/maintain/dept/edit",
        parm
      );
      if (res.code == 1) {
        //信息提示
        _this.$message.success("操作成功");
        //刷新部门信息
        _this.getDeptInfon(id);
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getUserList() {
      let obj = {};
      obj.name = this.queryForm.user;
      obj.plate = this.queryForm.plate;
      obj.deptId = this.deptId;
      obj.limit = this.limit;
      obj.page = this.currentPage;
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/maintain/dept/list", {
        params: obj,
      });
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
    },
    query() {
      this.getUserList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getUserList();
    },
    async getUserInfo(rowData) {
      let id = rowData.personnelId;
      //显示弹框
      this.infoVisible = true;
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/maintain/personnel/" + id
      );
      if (res.code == 1) {
        _this.staffInfo = [];
        _this.staffInfo = res.data;
        _this.staffInfo.sex = _this.staffInfo.sex == 1 ? "男" : "女";
        if (_this.staffInfo.situation == 1) {
          _this.staffInfo.situation = "在职";
        } else if (_this.staffInfo.situation == 2) {
          _this.staffInfo.situation = "试用期";
        } else if (_this.staffInfo.situation == 3) {
          _this.staffInfo.situation = "离职";
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getUserList();
    },
    toDevopsGroup() {
      let _this = this;
      //this.$router.push("/DevopsGroup")
      this.$router.push({
        name: "/DevopsGroup",
        params: {
          deptId: _this.deptId,
        },
      });
      sessionStorage.setItem("isActive", 0);
    },
  },
  beforeDestroy() {
    sessionStorage.setItem("devopsDeptId", "");
  },
};
</script>

<style lang="scss" scoped>
.con-wrap {
  display: flex;
  flex-direction: row;
}
.con-wrap .el-container {
  height: 100%;
  overflow: auto;
  background-color: #fff;
}
.top-btn {
  padding: 10px 0 0 20px;
}
table,
table tr th,
table tr td {
  border: 1px solid #dfdfdf;
}
.infoTable {
  border-collapse: collapse;
  line-height: 32px;
  font-size: 14px;
  color: #333;
}
.table-header {
  width: 120px;
  height: 32px;
  text-align: center;
  background-color: #ddeffd;
}
.table-con {
  width: 240px;
  height: 32px;
  text-align: left;
}
.infoTable span {
  padding-left: 12px;
}
.infoTable /deep/ .el-input__inner {
  height: 32px;
  padding-left: 12px;
}
.list-wrap {
  padding: 10px 20px 0 20px;
}
.list-wrap /deep/ .input-form-inline {
  padding-top: 0;
}
.con-top {
  height: 240px;
  margin-bottom: 20px;
  background: #fff;
}
// 模态框样式设置
.info-box /deep/ .el-dialog {
  width: 900px;
  height: 540px;
}
.info-box /deep/ .el-dialog__body {
  color: #333;
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.dialog-label {
  font-weight: bold;
}
.info-box /deep/ .el-row {
  height: 34px;
  line-height: 34px;
}
</style>
